import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';
import { Spin, Table, Modal, Progress } from 'antd';
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import { withCookies } from 'react-cookie';
import Constantes from '../../utilidades/Constantes'
import Utilidades from '../../utilidades/Utilidades'
import ServicioDatosConstantes from '../../servicios/ServicioDatosConstantes';
import FiltroColumna from '../../general/tabla/FiltroColumna'
import FiltroEtiqueta from '../../general/tabla/FiltroEtiqueta'
import _ from 'lodash';



class ReporteSolicitudes extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        descargando: false,

        filtro: {},
        filtroEtiquetas: [],
        filtroApi : {},
        paginacion: {
            current: 1,
            pageSize: 10,
        },
        cargandoTabla: true
    };

    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
        this.servicioDatosConstantes = new ServicioDatosConstantes(props);

        let contexto = this;
        this.ano = this.props.ano;
        this.filtroColumna = new FiltroColumna(props, (valores) => { contexto.setSumaState(valores, contexto) });
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.onRef(this)
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.onRef(undefined)
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario esté en sesion
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr != null) {
            const estados = await this.servicioDatosConstantes.obtenerEstadosSolicitud();
            let estadosSolicitudes = [];
            if (estados) {
                for (let estado of estados) {
                    estadosSolicitudes.push({ label: estado.estadoSolicitud, value: estado.id });
                }
            }
            await this.cargarDatosTabla(this);
            this.setSumaState({
                componente: this.ENUM_COMPONENTE.VER, cargando: false,
                estadosSolicitudes, usuario: usr
            });

        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
        // Esto le avisa al contenedor padre (ReportesUsuarios.js) que ya cargó lo datos
        this.props.onCargado(true);
    }

    async cambioAno( ano ){
        this.ano = ano;
        await this.cargarDatosTabla(this);
        // Indica al contenedor padre (ReportesUsuarios.js) que ya cargó lo datos
        this.props.onCargado(true);
    }

    // 'limpiarFiltro': Método (clearFilters) que es propio de la tabla antDesign para limpiar los filtros
    // 'confirmarFiltro': Método (confirm) que es própio de la tabla antDesign para aplicar el filtro
    // 'dataIndex': Retorna el campo que se está filtrando
    // 'selectedKeys': Retorna el valor a filtrar;
    async cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) {
        let filtro = contexto.state.filtro;
        if (dataIndex !== undefined) { // Si el filtro es aplicado, se agrega la columna filtrada
            filtro[dataIndex] = selectedKeys;
        }
        contexto.setSumaState({ filtro: filtro });

        // Se construye el filtroApi a partir de lo que fue filtrado en la tabla
        let filtroApi = {
            ...(filtro.codigoSolicitud && filtro.codigoSolicitud.length > 0 && { codigo: filtro.codigoSolicitud[0] }),
            ...(filtro.codigoSolicitudDependencia && filtro.codigoSolicitudDependencia.length > 0 && { solDependencia: filtro.codigoSolicitudDependencia[0] }),
            ...(filtro.fechaRegistro && filtro.fechaRegistro.length > 0 && { fechasRegistro: filtro.fechaRegistro[0] + '-' + filtro.fechaRegistro[1] }),
            ...(filtro.fechasOcupacion && filtro.fechasOcupacion.length > 0 && { fechasOcupacion: filtro.fechasOcupacion[0] + '-' + filtro.fechasOcupacion[1] }),
            ...(filtro.estadoSolicitud && filtro.estadoSolicitud.length > 0 && filtro.estadoSolicitud[0].opc && { estado: filtro.estadoSolicitud[0].opc.join() }),
            ...(filtro.estadoSolicitud && filtro.estadoSolicitud.length > 0 && filtro.estadoSolicitud[0].texto && { estadoDependencia: filtro.estadoSolicitud[0].texto }),
            ...(filtro.usuario && filtro.usuario.length > 0 && { usuario: filtro.usuario[0] }),
            ...(filtro.datosAdicionales && filtro.datosAdicionales.length > 0 && { datos: filtro.datosAdicionales[0] }),
            ...(filtro.localidad && filtro.localidad.length > 0 && { localidad: filtro.localidad[0] }),
            ...(filtro.tipoSolicitud && filtro.tipoSolicitud.length > 0 && { tipoSolicitud: filtro.tipoSolicitud[0] }),
            ...(filtro.dependencia && filtro.dependencia.length > 0 && { dependencia: filtro.dependencia[0] }),
            ano: this.ano,
            detallado:this.props.detallado
        };

        const paginacion = this.state.paginacion;
        let paginacionApi = {
            paginaActual:this.state.paginacion.current,
            paginaTamano:this.state.paginacion.pageSize,
            ordenarColumna:this.state.paginacion.ordenarColumna,
            orden: this.state.paginacion.orden
        }

        let cambio = false;
        // Primero valida si hubo cambio a nivel de filtro
        if( !_.isEqual(this.state.filtroApi, filtroApi) ){
            //console.log("Cambio filtro");
            paginacion.current = 1;
            paginacionApi.paginaActual = 1;
            cambio = true;
        }

        // Segundo valida si hubo cambio a nivel de paginación
        if( !cambio && !_.isEqual(this.state.paginacionApi, paginacionApi) ){
            //console.log("Cambio paginación");
            //console.log("paginacionApi",paginacionApi);
            cambio = true;
        }
        
        if( !cambio ){
            // Si no hubo cambio no se hace nada
            return;
        }

        contexto.setSumaState({  
            cargandoTabla: true, 
            filtro, 
            filtroApi, 
            paginacionApi, 
            paginacion
        });

        await this.servicioAdministracion.obtenerSolicitudes(
                {
                    ...filtroApi,
                    ...paginacionApi
                }
            )
            .then((respuestaApi) => {
                if (respuestaApi) {
                    
                    switch (respuestaApi.codigo) {
                        case Constantes.ENUMS_API.ADMINISTRACION.DATOS_RETORNADOS.id:
                            let tablaPaginada = respuestaApi.resultado;
                            const paginacion = this.state.paginacion;
                            paginacion.total = tablaPaginada.total;

                            contexto.setSumaState({
                                solicitudes: tablaPaginada.registros,
                                cargandoTabla: false,
                                paginacion
                            });

                            break;
                        default: break;
                    }
                    
                }
            }).then(() => {
                if (limpiarFiltro !== undefined) { limpiarFiltro(); }
                if (confirmarFiltro !== undefined) { confirmarFiltro(); }
            });
    }

    async descargarReporte() {
        let contexto = this;
        contexto.setSumaState({ descargando: true, porcentaje: 0 });
        await this.servicioAdministracion.descargarReporteSolicitudes(
            {
                ...this.state.filtroApi,
                ...this.state.paginacionApi,
                paginaActual : 1,
                paginaTamano : -1
            },
            (percentCompleted) => {
                contexto.setSumaState({ porcentaje: percentCompleted });
            }
        )
            .then((respuesta) => {
                if (respuesta) {
                    switch (respuesta.status) {
                        case 200:
                            const type = respuesta.headers['content-type'];
                            const nombre = respuesta.headers['filename'];
                            const blob = new Blob([respuesta.data], { type: type });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = nombre;
                            link.click();
                            link.remove();
                            this.setSumaState({ descargando: false });
                            break;
                        default:
                            this.setSumaState({ descargando: false });
                            Modal.error({ content: "No fue posible generar el reporte de solicitudes. [Cod:RS01]" });
                            break;
                    }
                }
            });
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const paginacion = this.state.paginacion;
        paginacion.current = pagination.current;
        paginacion.pageSize = pagination.pageSize;
        paginacion.ordenarColumna = sorter.field;
        paginacion.orden = sorter.order;
        this.setSumaState({  paginacion });
        await this.cargarDatosTabla(this);
    };

    render() {

        const { solicitudes, componente, estadosSolicitudes, descargando, porcentaje } = this.state;
        let { filtro } = this.state;
        filtro = filtro || {};
        let contexto = this;

        const columns = [
            {
                title: 'Código',
                align: 'center',
                dataIndex: 'codigoSolicitud',
                key: 'codigoSolicitud',
                width: 80,
                sorter: (a, b) => 0, //a.codigoSolicitud - b.codigoSolicitud,
                filteredValue: filtro.codigoSolicitud || null,
                ...this.filtroColumna.busquedaTexto(
                    'Código',
                    'codigoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Solicitud',
                align: 'center',
                dataIndex: 'codigoSolicitudDependencia',
                key: 'codigoSolicitudDependencia',
                width: 60,
                sorter: (a, b) => 0, //a.codigoSolicitudDependencia ? a.codigoSolicitudDependencia.localeCompare(b.codigoSolicitudDependencia) : 1,
                filteredValue: filtro.codigoSolicitudDependencia || null,
                ...this.filtroColumna.busquedaTexto(
                    'Solicitud',
                    'codigoSolicitudDependencia',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Fecha Registro',
                align: 'center',
                dataIndex: 'fechaRegistro',
                key: 'fechaRegistro',
                width: 100,
                sorter: (a, b) => 0, //moment(a.fechaTiempoRegistroEstandar, Constantes.FORMATO_FECHA_TIEMPO_ESTANDAR) - moment(b.fechaTiempoRegistroEstandar, Constantes.FORMATO_FECHA_TIEMPO_ESTANDAR),
                filteredValue: filtro.fechaRegistro || null,
                ...this.filtroColumna.busquedaFecha(
                    'Fecha Registro',
                    'fechaRegistro',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Fechas ocupación',
                dataIndex: 'fechasOcupacion',
                align: 'center',
                key: 'fechasOcupacion',
                width: 100,
                filteredValue: filtro.fechasOcupacion || null,
                ...this.filtroColumna.busquedaFecha(
                    'Fechas ocupación',
                    'fechasOcupacion',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                render(text, record) {
                    return (
                        <>
                            {record.fechasOcupacion.map((fechaOcupacion, index) =>
                                <span key={index} className="span-bloque lineh16">
                                    {fechaOcupacion}
                                </span>
                            )}

                            {record.fechasOcupacionOpcional.map((fechaOcupacion, index) =>
                                <span key={index} className="span-bloque lineh16 fecha-opcional ">
                                    {fechaOcupacion}
                                </span>
                            )}
                        </>
                    );
                },
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            {
                title: 'Tipo solicitud',
                dataIndex: 'tipoSolicitud',
                key: 'tipoSolicitud',
                sorter: (a, b) => 0, //a.tipoSolicitud ? a.tipoSolicitud.localeCompare(b.tipoSolicitud) : 1,
                filteredValue: filtro.tipoSolicitud || null,
                ...this.filtroColumna.busquedaTexto(
                    'Tipo solicitud',
                    'tipoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            {
                title: 'Estado',
                dataIndex: 'estadoSolicitud',
                key: 'estadoSolicitud',
                sorter: (a, b) => 0, //a.estadoSolicitud ? a.estadoSolicitud.localeCompare(b.estadoSolicitud) : 1,
                filteredValue: filtro.estadoSolicitud || null,
                ...this.filtroColumna.busquedaOpcionesConTexto(
                    'Estado',
                    'estadoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) },
                    estadosSolicitudes
                ),
                render(text, record) {
                    return (
                        <>
                            <span className="span-bloque"><strong>{text}</strong></span>
                            <span className="span-bloque">{record.estadoDependencia}</span>
                        </>
                    )
                },
                responsive: ['md'], /* visible en pantalla con ancho ≥ 768px*/
            },
            {
                title: 'Usuario',
                dataIndex: 'usuario',
                key: 'usuario',
                sorter: (a, b) => 0, //a.nombreUsuario ? a.nombreUsuario.localeCompare(b.nombreUsuario) : 1,
                filteredValue: filtro.usuario || null,
                ...this.filtroColumna.busquedaTexto(
                    'Usuario',
                    'usuario',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                render(text, record) {
                    return (
                        <>
                            {(record.idTipoUsuario === Constantes.ENUMS.TIPO_USUARIO.PERSONA_JURIDICA.id)
                                ? (
                                    <>
                                        <span className="span-bloque lineh16 texto-info02">{record.razonSocialUsuario}</span>
                                    </>
                                )
                                : (<></>)
                            }
                            <span className="span-bloque lineh16">{record.nombreUsuario}</span>
                            <span className="span-bloque lineh16 texto-info01">{record.tipoUsuario}</span>
                        </>
                    )
                },
                responsive: ['md'], /* visible en pantalla con ancho ≥ 768px*/
            },
            {
                title: 'Datos Adicionales',
                align: 'center',
                dataIndex: 'datosAdicionales',
                key: 'datosAdicionales',
                sorter: (a, b) => 0, 
                filteredValue: filtro.datosAdicionales || null,
                ...this.filtroColumna.busquedaTexto(
                    'Datos Adicionales',
                    'datosAdicionales',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                render(text, record) {
                    return (
                        <>
                            {Utilidades.interpretadorHTML(text)}
                        </>
                    )
                },
                responsive: ['xl'], /* visible en pantalla con ancho ≥ 1200px*/
            },
            {
                title: 'Dependencia',
                dataIndex: 'dependencia',
                key: 'dependencia',
                sorter: (a, b) => 0, 
                filteredValue: filtro.dependencia || null,
                ...this.filtroColumna.busquedaTexto(
                    'Dependencia',
                    'dependencia',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                render(text, record) {
                    return (
                        <>
                            <span className="span-bloque"><strong>{text}</strong></span>
                            <span className="span-bloque">{record.entidad}</span>
                        </>
                    )
                },
                responsive: ['lg'], /* visible en pantalla con ancho ≥ 992px*/
            },
            {
                title: 'Localidad',
                align: 'center',
                dataIndex: 'localidad',
                key: 'localidad',
                sorter: (a, b) => 0, /*((a, b) => {
                    if (a.localidad && b.localidad)
                        return a.localidad.localeCompare(b.localidad);
                    else if (a.localidad && !b.localidad) {
                        return -1;
                    }
                    else if (!a.localidad && b.localidad) {
                        return 1;
                    }
                    else
                        return 0;
                }),*/
                filteredValue: filtro.localidad || null,
                ...this.filtroColumna.busquedaTexto(
                    'Localidad',
                    'localidad',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['xl'], /* visible en pantalla con ancho ≥ 1200px*/
            },
        ];

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                            <Modal
                                visible={descargando}
                                closable={false}
                                footer={null}
                                width={320}
                                style={{ textAlign: 'center' }}
                            >
                                <label style={{ marginBottom: 13, display: 'block' }}>
                                    Generando reporte...
                                </label>
                                <Progress type="circle" percent={porcentaje} width={80} />
                            </Modal>

                            {
                                this.state.filtroEtiquetas.length > 0 ?
                                    (<div className="seccion-filtros-etiquetas">
                                        <div className="titulo-filtro-etiquetas">
                                            <label>Filtros <SearchOutlined /> :</label>
                                        </div>

                                        {
                                            this.state.filtroEtiquetas.map((filtroEtiqueta, i) => {
                                                return (
                                                    <FiltroEtiqueta key={i}
                                                        dataIndex={filtroEtiqueta.dataIndex}
                                                        texto={filtroEtiqueta.texto}
                                                        onClose={filtroEtiqueta.borrarFiltro} />
                                                )
                                            })
                                        }
                                    </div>)
                                    :
                                    (<></>)
                            }

                            <Table columns={columns}
                                dataSource={solicitudes} 
                                onChange={this.handleTableChange}
                                pagination={this.state.paginacion}
                                loading={this.state.cargandoTabla}/>
                        </Spin>
                    )
                    :
                    (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                        (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                        : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:REPSOLICITUDES]</label>) : (<></>))
                }
            </div>

        );

    }

}

export default withRouter(withCookies(ReporteSolicitudes));